import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/paper-clip.png'


const _withScopeId = n => (_pushScopeId("data-v-5c822bf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "col-12"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row wrap" }, "Equipment events", -1 /* HOISTED */))
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "q-pa-md" }
const _hoisted_5 = {
  class: "row justifi-between",
  style: {"width":"100%"}
}
const _hoisted_6 = { style: {"width":"90%"} }
const _hoisted_7 = {
  style: {"width":"10%"},
  class: "row justify-end"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { style: {"font-size":"10px"} }
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 0,
  class: "paper-icon",
  src: _imports_0,
  height: "14",
  alt: "Paper clip icon"
}
const _hoisted_12 = {
  "aria-label": "comment-table",
  class: "collapse-details"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { id: "files" }, "Files"),
    /*#__PURE__*/_createElementVNode("th", { class: "equipment" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "red-asterisk" }, "*"),
      /*#__PURE__*/_createTextVNode("Equipment ")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "trade" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "red-asterisk" }, "*"),
      /*#__PURE__*/_createTextVNode("Trade ")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "rootCauseFailure" }, " Failure root cause "),
    /*#__PURE__*/_createElementVNode("th", { class: "shortfall" }, "Shortfall"),
    /*#__PURE__*/_createElementVNode("th", { id: "author" }, "Author"),
    /*#__PURE__*/_createElementVNode("th", { id: "analysis-type" }, "Analysis Type")
  ])
], -1 /* HOISTED */))
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 0,
  class: "q-pt-xs text-weight-bold"
}
const _hoisted_16 = {
  key: 1,
  class: "q-pt-xs text-weight-bold"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "text-weight-thin" }
const _hoisted_19 = {
  key: 1,
  class: "text-weight-bold"
}
const _hoisted_20 = { class: "equi-box col" }
const _hoisted_21 = { style: {"font-size":"smaller"} }
const _hoisted_22 = { class: "trade-box" }
const _hoisted_23 = { class: "col" }
const _hoisted_24 = {
  key: 0,
  class: "tag-row"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "row filters-events items-center" }
const _hoisted_27 = { class: "label filter-type self-start" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Search ")
const _hoisted_29 = { class: "label q-ml-lg filter-type" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Filter by type ")
const _hoisted_31 = { class: "label q-ml-lg filter-type" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Filter by status ")
const _hoisted_33 = { class: "label q-ml-lg filter-type" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Filter by author ")
const _hoisted_35 = { class: "q-ml-md filter-type" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "q-my-auto" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "event-log-title" }, "Event Changelog")
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_EquipmentStatusIcon = _resolveComponent("EquipmentStatusIcon")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_EditMenu = _resolveComponent("EditMenu")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_AddEquipmentCommentPopin = _resolveComponent("AddEquipmentCommentPopin")!
  const _component_EditEquipmentCommentPopin = _resolveComponent("EditEquipmentCommentPopin")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_ctx.equipment)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_q_card, { class: "q-mb-lg" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row justify-between card-title flex-center" }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createElementVNode("div", null, [
                  (!_ctx.isUserUnknownOrGuest())
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 0,
                        outline: "",
                        rounded: "",
                        "no-caps": "",
                        class: "main-button q-mr-md",
                        label: "New comment",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.displayAddCommentPopin(true)))
                      }))
                    : _createCommentVNode("v-if", true),
                  (!_ctx.isUserUnknownOrGuest())
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 1,
                        outline: "",
                        rounded: "",
                        "no-caps": "",
                        class: "main-button",
                        label: "Export Events",
                        onClick: _ctx.exportEDExcel
                      }, null, 8 /* PROPS */, ["onClick"]))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_q_separator),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_q_table, {
                  rows: _ctx.commentsByStatuses(_ctx.equipment),
                  columns: _ctx.columnsStatuses,
                  "row-key": "name",
                  pagination: _ctx.pagination,
                  "rows-per-page-label": "Status per page",
                  class: "events-table"
                }, {
                  body: _withCtx((props) => [
                    _withDirectives(_createVNode(_component_q_tr, { props: props }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_td, { colspan: "100%" }, {
                          default: _withCtx(() => [
                            (props.row.status.status)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass(["text-left row status-line", _ctx.getStatusBorderClass(props.row.status.status)])
                                }, [
                                  _createVNode(_component_EquipmentStatusIcon, {
                                    status: props.row.status.status
                                  }, null, 8 /* PROPS */, ["status"]),
                                  _createElementVNode("div", {
                                    class: _normalizeClass([_ctx.getClass(props.row.status), "q-ml-xs"])
                                  }, _toDisplayString(_ctx.generateSeperatorText(
                          props.row.status,
                          props.row.statusEndDate
                        )), 3 /* TEXT, CLASS */)
                                ], 2 /* CLASS */))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["props"]), [
                      [_vShow, props.row.comments.length > 0]
                    ]),
                    _withDirectives(_createVNode(_component_q_tr, { props: props }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_table, {
                          rows: props.row.comments,
                          "hide-pagination": true,
                          columns: _ctx.columnsComments,
                          filter: _ctx.filter,
                          pagination: { rowsPerPage: 0 },
                          class: "status-table"
                        }, {
                          body: _withCtx((props) => [
                            _createVNode(_component_q_tr, { props: props }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_td, {
                                  key: "date",
                                  style: {"width":"10%"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.formatDate(props.row.date)), 1 /* TEXT */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */),
                                _createVNode(_component_q_td, {
                                  key: "comment",
                                  style: {"width":"37%"}
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_5, [
                                      _createElementVNode("div", _hoisted_6, _toDisplayString(props.row.comment), 1 /* TEXT */),
                                      _createElementVNode("div", _hoisted_7, [
                                        (props.row.isAlert)
                                          ? (_openBlock(), _createBlock(_component_q_icon, {
                                              key: 0,
                                              name: "warning"
                                            }))
                                          : _createCommentVNode("v-if", true)
                                      ])
                                    ])
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */),
                                _createVNode(_component_q_td, {
                                  key: "informationType",
                                  style: {"width":"10%"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.getInformationTypeLabel(props.row.informationType)), 1 /* TEXT */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */),
                                _createVNode(_component_q_td, {
                                  key: "qualityKpi",
                                  style: {"width":"10%"}
                                }, {
                                  default: _withCtx(() => [
                                    (props.row.qualityKpi)
                                      ? (_openBlock(), _createBlock(_component_q_chip, {
                                          key: 0,
                                          square: "",
                                          icon: _ctx.icon(props.row.qualityKpi),
                                          class: _normalizeClass([_ctx.getClassQualityIcon(props.row.qualityKpi), "text-uppercase"]),
                                          label: props.row.qualityKpi,
                                          "text-color": "white"
                                        }, null, 8 /* PROPS */, ["icon", "class", "label"]))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */),
                                _createVNode(_component_q_td, {
                                  key: "woNumber",
                                  style: {"width":"5%"}
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_8, [
                                      _createElementVNode("div", _hoisted_9, _toDisplayString(props.row.woNumber), 1 /* TEXT */),
                                      (props.row.woNumber)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            class: "main-link",
                                            target: "_blank",
                                            href: `https://azrpscefappgwst.scef.iasp.tgscloud.net/tracking-for-wo?country=${_ctx.getSelectedCountryBlocInShort}&${encodeURIComponent(
                              'WO n°'
                            )}=${props.row.woNumber}`
                                          }, [
                                            _createVNode(_component_q_icon, {
                                              size: "14px",
                                              name: "launch"
                                            })
                                          ], 8 /* PROPS */, _hoisted_10))
                                        : _createCommentVNode("v-if", true)
                                    ])
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */),
                                _createVNode(_component_q_td, {
                                  key: "woStatus",
                                  style: {"width":"5%"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(props.row.woStatus), 1 /* TEXT */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */),
                                _createVNode(_component_q_td, {
                                  key: "actions",
                                  style: {"width":"5%"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_EditMenu, {
                                      author: props.row.author,
                                      onOnEdit: ($event: any) => (_ctx.editEquipmentComment(props.row)),
                                      onOnDelete: ($event: any) => (_ctx.openConfirmDeleteComment(props.row))
                                    }, null, 8 /* PROPS */, ["author", "onOnEdit", "onOnDelete"])
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */),
                                _createVNode(_component_q_td, { style: {"width":"5%"} }, {
                                  default: _withCtx(() => [
                                    (props.row.equipmentCommentFiles?.length > 0)
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */),
                                _createVNode(_component_q_td, { style: {"width":"3%"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_btn, {
                                      size: "md",
                                      flat: "",
                                      class: "red text-weight-bold",
                                      icon: 
                            props.row.expand ? 'expand_less' : 'expand_more'
                          ,
                                      onClick: ($event: any) => (props.row.expand = !props.row.expand)
                                    }, null, 8 /* PROPS */, ["icon", "onClick"])
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["props"]),
                            _withDirectives(_createVNode(_component_q_tr, {
                              props: props,
                              class: "collapse"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_td, {
                                  colspan: "100%",
                                  class: "td-table-collapse"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("table", _hoisted_12, [
                                      _hoisted_13,
                                      _createElementVNode("tbody", null, [
                                        _createElementVNode("tr", null, [
                                          _createElementVNode("td", null, [
                                            (
                                    props.row.equipmentCommentFiles?.length ||
                                    _ctx.getEquipmentDetails.failureRootCause
                                  )
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                                  (
                                      props.row.equipmentCommentFiles?.length >
                                      0
                                    )
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(props.row.equipmentCommentFiles?.length) + " files available : ", 1 /* TEXT */))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(props.row.equipmentCommentFiles?.length) + " file available : ", 1 /* TEXT */)),
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row
                                      .equipmentCommentFiles, (file) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      key: file.id,
                                                      class: "cursor-pointer",
                                                      onClick: ($event: any) => (_ctx.downloadFile(file.name))
                                                    }, [
                                                      _createVNode(_component_q_icon, {
                                                        name: "download",
                                                        size: "xs"
                                                      }),
                                                      _createElementVNode("span", _hoisted_18, _toDisplayString(file.name), 1 /* TEXT */)
                                                    ], 8 /* PROPS */, _hoisted_17))
                                                  }), 128 /* KEYED_FRAGMENT */))
                                                ]))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_19, " No file(s) available "))
                                          ]),
                                          _createElementVNode("td", _hoisted_20, [
                                            _createElementVNode("div", null, [
                                              _createElementVNode("b", null, _toDisplayString(_ctx.equipmentDetails(
                                      props.row.status?.equipmentDetailsId
                                    )?.equipmentItem), 1 /* TEXT */)
                                            ]),
                                            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.showEquipmentHierarchy(
                                      props.row.status?.equipmentDetailsId
                                    )), 1 /* TEXT */)
                                          ]),
                                          _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.tradeValue(props.row.status?.tradeTypeId)
                                    ?.name), 1 /* TEXT */),
                                          _createElementVNode("td", _hoisted_23, [
                                            (props.row.status?.equipmentMajorFailure)
                                              ? (_openBlock(), _createBlock(_component_q_checkbox, {
                                                  key: 0,
                                                  modelValue: 
                                    props.row.status.equipmentMajorFailure
                                  ,
                                                  "onUpdate:modelValue": ($event: any) => ((
                                    props.row.status.equipmentMajorFailure
                                  ) = $event),
                                                  label: "Equipment major failure",
                                                  disable: ""
                                                }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]))
                                              : _createCommentVNode("v-if", true),
                                            (props.row.status?.gasOrOilLeak)
                                              ? (_openBlock(), _createBlock(_component_q_checkbox, {
                                                  key: 1,
                                                  modelValue: props.row.status.gasOrOilLeak,
                                                  "onUpdate:modelValue": ($event: any) => ((props.row.status.gasOrOilLeak) = $event),
                                                  label: "Gas or oil leak",
                                                  disable: ""
                                                }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]))
                                              : _createCommentVNode("v-if", true),
                                            (props.row.status?.fireConfirmed)
                                              ? (_openBlock(), _createBlock(_component_q_checkbox, {
                                                  key: 2,
                                                  modelValue: props.row.status.fireConfirmed,
                                                  "onUpdate:modelValue": ($event: any) => ((props.row.status.fireConfirmed) = $event),
                                                  label: "Fire confirmed",
                                                  disable: ""
                                                }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]))
                                              : _createCommentVNode("v-if", true)
                                          ]),
                                          _createElementVNode("td", null, [
                                            (props.row.status)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                                  _createVNode(_component_q_input, {
                                                    modelValue: 
                                      props.row.status.productionShortfall
                                    ,
                                                    "onUpdate:modelValue": ($event: any) => ((
                                      props.row.status.productionShortfall
                                    ) = $event),
                                                    label: "Production Shortfall",
                                                    suffix: _ctx.getProductionShortfallUnit,
                                                    class: "tag",
                                                    readonly: ""
                                                  }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "suffix"]),
                                                  _createVNode(_component_q_input, {
                                                    modelValue: 
                                      props.row.status.waterInjectShortfall
                                    ,
                                                    "onUpdate:modelValue": ($event: any) => ((
                                      props.row.status.waterInjectShortfall
                                    ) = $event),
                                                    label: "Water Inject Shortfall",
                                                    suffix: _ctx.getWaterInjectShortfallUnit,
                                                    class: "tag",
                                                    readonly: ""
                                                  }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "suffix"]),
                                                  _createVNode(_component_q_input, {
                                                    modelValue: props.row.status.flaring,
                                                    "onUpdate:modelValue": ($event: any) => ((props.row.status.flaring) = $event),
                                                    label: "Flaring",
                                                    suffix: _ctx.getFlaringUnit,
                                                    class: "tag",
                                                    readonly: ""
                                                  }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "suffix"])
                                                ]))
                                              : _createCommentVNode("v-if", true)
                                          ]),
                                          _createElementVNode("td", null, [
                                            _createTextVNode(_toDisplayString(props.row.author) + " ", 1 /* TEXT */),
                                            _createVNode(_component_q_btn, {
                                              round: "",
                                              size: "md",
                                              class: "event-clog q-px-sm q-py-xs q-ml-sm",
                                              unelevated: "",
                                              outline: "",
                                              "text-color": "darkgrey",
                                              icon: "history",
                                              onClick: ($event: any) => (_ctx.eventLogClick(props.row))
                                            }, null, 8 /* PROPS */, ["onClick"])
                                          ]),
                                          (props.row.informationType !== 'other')
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_25, _toDisplayString(_ctx.getAnalysisTypeLabel(props.row.analysisType)), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true)
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["props"]), [
                              [_vShow, props.row.expand]
                            ])
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["rows", "columns", "filter"])
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["props"]), [
                      [_vShow, props.row.comments.length > 0]
                    ])
                  ]),
                  "top-left": _withCtx(() => [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("span", _hoisted_27, [
                        _hoisted_28,
                        _createVNode(_component_q_input, {
                          modelValue: _ctx.filter,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter) = $event)),
                          dense: "",
                          debounce: "300",
                          outlined: ""
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_q_icon, { name: "search" })
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                      ]),
                      _createElementVNode("span", _hoisted_29, [
                        _hoisted_30,
                        _createVNode(_component_q_select, {
                          modelValue: _ctx.typeFilter,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.typeFilter) = $event)),
                          options: _ctx.getInformationTypesForFilter(),
                          "option-label": "label",
                          "option-value": "value",
                          standout: "",
                          "map-options": "",
                          "emit-value": "",
                          "bottom-slots": "",
                          class: "q-mt-md main-dropdown-100",
                          "bg-color": "white",
                          borderless: "",
                          "input-style": {
                      fontFamily: 'Roboto',
                      fontSize: '12px',
                      lineHeight: '16px',
                    },
                          outlined: "",
                          dense: ""
                        }, null, 8 /* PROPS */, ["modelValue", "options"])
                      ]),
                      _createElementVNode("span", _hoisted_31, [
                        _hoisted_32,
                        _createVNode(_component_q_select, {
                          modelValue: _ctx.equipmentStatusFilter,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.equipmentStatusFilter) = $event)),
                          options: _ctx.equipmentStatuses,
                          "option-label": "label",
                          "option-value": "value",
                          standout: "",
                          "map-options": "",
                          "emit-value": "",
                          "bottom-slots": "",
                          class: "q-mt-md main-dropdown-100",
                          "bg-color": "white",
                          borderless: "",
                          "input-style": {
                      fontFamily: 'Roboto',
                      fontSize: '12px',
                      lineHeight: '16px',
                    },
                          outlined: "",
                          dense: ""
                        }, null, 8 /* PROPS */, ["modelValue", "options"])
                      ]),
                      _createElementVNode("span", _hoisted_33, [
                        _hoisted_34,
                        _createVNode(_component_q_select, {
                          modelValue: _ctx.authorFilter,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.authorFilter) = $event)),
                          options: _ctx.authors,
                          "option-label": "label",
                          "option-value": "value",
                          standout: "",
                          "map-options": "",
                          "emit-value": "",
                          "bottom-slots": "",
                          class: "q-mt-md main-dropdown-100",
                          "bg-color": "white",
                          borderless: "",
                          "input-style": {
                      fontFamily: 'Roboto',
                      fontSize: '12px',
                      lineHeight: '16px',
                    },
                          outlined: "",
                          dense: ""
                        }, null, 8 /* PROPS */, ["modelValue", "options"])
                      ]),
                      (!_ctx.isUserUnknownOrGuest())
                        ? (_openBlock(), _createBlock(_component_q_btn, {
                            key: 0,
                            outline: "",
                            rounded: "",
                            "no-caps": "",
                            class: "main-button q-ml-md",
                            label: "Reset filters",
                            onClick: _ctx.resetFilters
                          }, null, 8 /* PROPS */, ["onClick"]))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_q_checkbox, {
                          modelValue: _ctx.hideAutomaticCommentsFilter,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.hideAutomaticCommentsFilter) = $event)),
                          style: {"font-size":"small","font-weight":"bold","color":"grey","white-space":"nowrap"},
                          label: "Hide Automatic status changed",
                          class: "hide-automatic-status-checkbox"
                        }, null, 8 /* PROPS */, ["modelValue"])
                      ])
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["rows", "columns", "pagination"])
              ])
            ])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_AddEquipmentCommentPopin),
        _createVNode(_component_EditEquipmentCommentPopin),
        _createVNode(_component_ConfirmDialog, {
          title: "Delete comment",
          message: _ctx.confirmDeleteCommentMessage,
          open: _ctx.displayConfirmDeleteCommentDialog,
          onOnClose: _ctx.closeConfirmDeleteComment,
          onOnConfirm: _ctx.onConfirmDeleteComment
        }, null, 8 /* PROPS */, ["message", "open", "onOnClose", "onOnConfirm"]),
        _createVNode(_component_q_dialog, {
          modelValue: _ctx.showEventLog,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showEventLog) = $event)),
          persistent: "",
          "max-width": "400px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card, { style: {"width":"600px","max-width":"80vw"} }, {
              default: _withCtx(() => [
                _createVNode(_component_q_card_section, { class: "row justify-between q-py-xs" }, {
                  default: _withCtx(() => [
                    _hoisted_36,
                    _createVNode(_component_q_card_actions, null, {
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_q_btn, {
                          icon: "close",
                          flat: "",
                          round: "",
                          dense: ""
                        }, null, 512 /* NEED_PATCH */), [
                          [_directive_close_popup]
                        ])
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_q_card_section, {
                  style: {"max-height":"60vh"},
                  class: "scroll"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_table, {
                      class: "eventLog-sticky-header-table",
                      rows: _ctx.eventLogRows,
                      columns: _ctx.columns,
                      "row-key": "name",
                      "hide-pagination": true,
                      "no-data-label": "No records found"
                    }, null, 8 /* PROPS */, ["rows", "columns"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"])
      ]))
    : _createCommentVNode("v-if", true)
}